import { render, staticRenderFns } from "./EmployeeDetailsContainer.vue?vue&type=template&id=01d1c447"
import script from "./EmployeeDetailsContainer.vue?vue&type=script&lang=js"
export * from "./EmployeeDetailsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports